import { render } from "./SponsorPortal.vue?vue&type=template&id=5b15ab0a&scoped=true"
import script from "./SponsorPortal.vue?vue&type=script&lang=js"
export * from "./SponsorPortal.vue?vue&type=script&lang=js"

import "./SponsorPortal.vue?vue&type=style&index=0&id=5b15ab0a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b15ab0a"]])

export default __exports__